import React from 'react';
import { useSelector } from 'react-redux';
import moment from 'moment';
import { CheckCircle, ErrorOutline } from '@material-ui/icons';

import IconCopy from '../../../assets/icons/Copy';
// import Trash from '../../../assets/icons/Trash';
import { useNotificationProvider } from '../../../components/notifications/NotificationProvider';
import { currencyFormatter } from '../../../utils';
// import useStandaloneCartActions from '../../../hooks/useStandaloneCartActions';

import './standalone-cart-row.scss';

export const StandaloneCartRow = ({ cartItem, onSelectItem, isSelected, onDeleted }) => {
      const { availableShops, activeShopId } = useSelector((state) => state.shops);
      const shopData = availableShops && activeShopId && availableShops[activeShopId];

      // const { onDeleteStandaloneCart } = useStandaloneCartActions();

      const { showToast } = useNotificationProvider();

      const timeDate = new Date(cartItem.createdAt.seconds * 1000);

      const isConverted = cartItem.totalOrderAmount > 0;

      const isStandaloneCartEmpty = !cartItem?.products || cartItem?.products.length === 0;

      const copyToClipboard = () => {
            if (!isStandaloneCartEmpty) {
                  showToast({
                        description: 'Link copied to clipboard',
                        type: 'info',
                  });
                  navigator.clipboard.writeText(cartItem?.cartRecoveryUrl);
            }
      };

      // const handleDelete = async () => {
      //       const result = await onDeleteStandaloneCart(cartItem.id);
      //
      //       if (result.success) {
      //             showToast({
      //                   description: 'Cart deleted successfully',
      //                   type: 'success',
      //             });
      //
      //             if (onDeleted) {
      //                   onDeleted();
      //             }
      //       } else {
      //             showToast({
      //                   description: 'Failed to delete cart',
      //                   type: 'error',
      //             });
      //             console.error('Failed to delete cart:', result.error);
      //       }
      // };

      return (
            <li className={`daily-cart-row ${isSelected ? 'selected' : ''}`} onClick={() => onSelectItem(cartItem)}>
                  <div className="left-container">
                        <div className="time-container">
                              <span className="time">{moment(timeDate).format('hh:mm A')}</span>
                        </div>
                        <div className="email-content">
                              <span className="sender">{cartItem.customerFullName ? cartItem.customerFullName : ""}</span>
                              <span className="details">{cartItem.customerEmail ? cartItem.customerEmail : "Unassigned cart"}</span>
                        </div>
                  </div>

                  <div className="right-container">
                        <div className={`conversion-badge ${isConverted ? 'converted' : 'not-converted'}`}>
                              {isConverted ? (
                                    <>
                                          <CheckCircle className="icon" />
                                          <span>{currencyFormatter(cartItem.totalOrderAmount, shopData.currencyCode)}</span>
                                    </>
                              ) : (
                                    <>
                                          <ErrorOutline className="icon" />
                                          <span>Not Converted</span>
                                    </>
                              )}
                        </div>

                        <div className="icons-container">
                              <div
                                    className={`copy-link-action ${isStandaloneCartEmpty && 'copy-link-action-disabled'}`}
                                    onClick={(e) => {
                                          e.stopPropagation();
                                          copyToClipboard();
                                    }}
                              >
                                    <IconCopy />
                                    <span className="tooltip-text">{isStandaloneCartEmpty ? "Cart is empty" : "Copy cart link"}</span>
                              </div>

                              {/*<div className="copy-link-action" onClick={(e) => {*/}
                              {/*      e.stopPropagation();*/}
                              {/*      handleDelete();*/}
                              {/*}}>*/}
                              {/*      <Trash fill="#be1919" width={17} height={17} />*/}
                              {/*      <span className="tooltip-text">Delete Cart</span>*/}
                              {/*</div>*/}
                        </div>
                  </div>
            </li>
      )
};
